import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import LoadingSpinner from './components/common/LoadingSpinner';
import SimpleLoader from './components/common/SimpleLoader';


// Redux actions
import { setLoading } from './store/slices/uiSlice';

import { doc, setDoc, increment } from 'firebase/firestore';
import { db } from './firebaseConfig';

import { lazyWithRetry } from './utils/lazyWithRetry';

// Lazy load Page Components with retry logic
const HomePage = lazyWithRetry(() => import('./pages/HomePage'));
const ServicesPage = lazyWithRetry(() => import('./pages/ServicesPage'));
const ForClientsPage = lazyWithRetry(() => import('./pages/ForClientsPage'));
const ForCandidatesPage = lazyWithRetry(() => import('./pages/ForCandidatesPage'));
const CareersPage = lazyWithRetry(() => import('./pages/CareersPage'));
const ContactPage = lazyWithRetry(() => import('./pages/ContactPage'));
const BlogPage = lazyWithRetry(() => import('./pages/BlogPage'));
const BlogPostPage = lazyWithRetry(() => import('./pages/BlogPostPage'));
const LoginPage = lazyWithRetry(() => import('./pages/LoginPage'));
const POSHProfessionalsPage = lazyWithRetry(() => import('./pages/POSHProfessionalsPage'));
const GalleryPage = lazyWithRetry(() => import('./pages/GalleryPage'));

const AdminDashboard = lazyWithRetry(() => import('./pages/AdminDashboard'));

function App() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.ui);

  useEffect(() => {
    // Simulate initial loading with shorter duration
    dispatch(setLoading(true));
    const timer = setTimeout(() => {
      dispatch(setLoading(false));
    }, 500); // Further reduced to 500ms for better performance

    // Track website visit
    const trackVisit = async () => {
      if (!sessionStorage.getItem('hasVisited')) {
        try {
          const visitDocRef = doc(db, 'analytics', 'visits');
          await setDoc(visitDocRef, { count: increment(1) }, { merge: true });
          sessionStorage.setItem('hasVisited', 'true');
        } catch (error) {
          console.error("Error tracking visit:", error);
        }
      }
    };
    trackVisit();

    return () => clearTimeout(timer);
  }, [dispatch]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <div className="App min-h-[100dvh] bg-white">
        <Header />
        <main className="flex-1">
          <Suspense fallback={<SimpleLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              {/* <Route path="/about" element={<AboutPage />} /> */}
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/posh-professionals" element={<POSHProfessionalsPage />} />
              {/* <Route path="/industries" element={<IndustriesPage />} /> */}
              <Route path="/for-clients" element={<ForClientsPage />} />
              <Route path="/for-candidates" element={<ForCandidatesPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/login" element={<LoginPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
            
              
